import styled from "styled-components";
import { Icon } from "./index";

export default styled(Icon)`
  font-size: 14px;
  cursor: pointer;
`;
